<template>
    <v-container fluid class="login-container">
    <view-card-template> 

        <template #viewHeader>
            <view-app-bar></view-app-bar>
        </template>
        <template #cardTitle>
            <span class="primaryLogo">CS</span><span class="secondaryLogo">Cancel</span>
        </template>
        <template #cardBody>
            <v-row v-if="strCompanyName !=='Homesite'">
                <v-col sm="4" v-if="isDate === false">
                    <v-select label="Search Fields" class="mx-4" :items="dropDown"
                    v-model="currentSelection"
                        @input="updateBoolean(currentSelection)"></v-select>
                </v-col>
                <v-col sm="5" v-if="isDate === true">
                    <v-select label="Search Fields" class="mx-4" :items="dropDown"
                    v-model="currentSelection"
                        @input="updateBoolean(currentSelection)"></v-select>
                </v-col>
                <v-col sm="6" v-if="isDate === false">
                    <v-text-field class="mx-4" label="Search" hide-details v-model="inputValue" />
                </v-col>
                <v-col sm="3" v-if="isDate === true">
                    <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition"
                        offset-y class="mx-4" min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="date" label="Start Date" readonly v-bind="attrs"
                                v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col sm="3" v-if="isDate === true">
                    <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition"
                        offset-y class="mx-4" min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="endDate" label="End Date" readonly v-bind="attrs"
                                v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="endDate" @input="menu3 = false"></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row v-if="strCompanyName ==='Homesite'">
                <v-col sm="4" v-if="isDate === false">
                    <v-select label="Search Fields" class="mx-4" :items="csgDropDown"
                    v-model="currentSelection"
                        @input="updateBoolean(currentSelection)"></v-select>
                </v-col>
                <v-col sm="5" v-if="isDate === true">
                    <v-select label="Search Fields" class="mx-4" :items="csgDropDown"
                    v-model="currentSelection"
                        @input="updateBoolean(currentSelection)"></v-select>
                </v-col>
                <v-col sm="6" v-if="isDate === false">
                    <v-text-field class="mx-4" label="Search" hide-details v-model="inputValue" />
                </v-col>
                <v-col sm="3" v-if="isDate === true">
                    <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition"
                        offset-y class="mx-4" min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="date" label="Start Date" readonly v-bind="attrs"
                                v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col sm="3" v-if="isDate === true">
                    <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition"
                        offset-y class="mx-4" min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="endDate" label="End Date" readonly v-bind="attrs"
                                v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="endDate" @input="menu3 = false"></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row>
                <v-col sm="2">
                    <v-btn v-on:click="getData(currentSelection, inputValue)"
                    class="mr-4 my-4" color="blue"
                        elevation="2" width="60%">
                        Search
                    </v-btn>
                </v-col>
                <v-col sm="2">
                    <v-btn v-on:click="reset($event)" class="mr-4 my-4" color="blue"
                    elevation="2" width="60%">
                        Reset
                    </v-btn>
                </v-col>
                <v-col sm="8"></v-col>
            </v-row>
            <v-row class="mt-3 borderBottomThinSolidGray marginNone" >
              <v-col sm="3" v-if="(initialData.length > 0 || tableData.length > 0)
                && isDate === false">
                    <v-text-field class="mx-4" label="Filter" hide-details v-model="search">
                    </v-text-field>
                </v-col>
                <v-col sm="5" v-if="(initialData.length > 0 || tableData.length > 0)
                && isDate === true">
                    <v-text-field class="mx-4" label="Filter" hide-details v-model="search">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-data-table :headers="csgHeaders" :items="tableData" :page="1" :pageStart="2"
            :pageStop="2" :items-per-page="5"
                :search="search" light calculate-widths show-select
                class="expanding-v-data-table elevation-1" width="100%" :footer-props="{
                    prevIcon: '<',
                    showCurrentPage: true,
                    nextIcon: '>'
                }" v-if="tableData.length > 0 && strCompanyName === 'Homesite'">
                <template v-slot:[`item.controls`]="props">
                    <v-container>
                        <v-avatar size="x-large" rounded="0" color="primary"
                        @click="onButtonClick(props.item)">
                            <img src="../assets/pdf.png" alt="pdfButton">
                        </v-avatar>
                    </v-container>
                </template>
                <template v-slot:top="{ pagination, options, updateOptions }">
                    <v-data-footer prev-icon="<" :show-current-page="true" next-icon=">"
                      :pagination="pagination"
                        :options="options" @update:options="updateOptions"
                        items-per-page-text="$vuetify.dataTable.itemsPerPageText" />
                </template>
            </v-data-table>
            <v-data-table :headers="csgHeadersInitial" :items="initialData" :page="1"
            :pageStart="2" :pageStop="2"
                :items-per-page="5" :search="search" light calculate-widths show-select
                class="expanding-v-data-table elevation-1" width="100%" :footer-props="{
                    prevIcon: '<',
                    showCurrentPage: true,
                    nextIcon: '>'
                }"
                v-if="initialData.length > 0 && tableData.length === 0 && strCompanyName === 'Homesite'">
                <template v-slot:top="{ pagination, options, updateOptions }">
                    <v-data-footer prev-icon="<" :show-current-page="true"
                    next-icon=">" :pagination="pagination"
                        :options="options" @update:options="updateOptions"
                        items-per-page-text="$vuetify.dataTable.itemsPerPageText" />
                </template>
            </v-data-table>
            <v-data-table :headers="headers" :items="tableData" :page="1" :pageStart="2"
            :pageStop="2" :items-per-page="5"
                :search="search" light calculate-widths show-select
                class="expanding-v-data-table elevation-1" width="100%" :footer-props="{
                    prevIcon: '<',
                    showCurrentPage: true,
                    nextIcon: '>'
                }" v-if="tableData.length > 0 && strCompanyName !== 'Homesite'">
                <template v-slot:[`item.controls`]="props">
                    <v-container>
                        <v-avatar size="x-large" rounded="0" color="primary"
                        @click="onButtonClick(props.item)">
                            <img src="../assets/pdf.png" alt="pdfButton">
                        </v-avatar>
                    </v-container>
                </template>
                <template v-slot:top="{ pagination, options, updateOptions }">
                    <v-data-footer prev-icon="<" :show-current-page="true" next-icon=">"
                      :pagination="pagination"
                        :options="options" @update:options="updateOptions"
                        items-per-page-text="$vuetify.dataTable.itemsPerPageText" />
                </template>
            </v-data-table>
            <v-data-table :headers="headersInitial" :items="initialData" :page="1"
            :pageStart="2" :pageStop="2"
                :items-per-page="5" :search="search" light calculate-widths show-select
                class="expanding-v-data-table elevation-1" width="100%" :footer-props="{
                    prevIcon: '<',
                    showCurrentPage: true,
                    nextIcon: '>'
                }"
                v-if="initialData.length > 0 && tableData.length === 0 && strCompanyName !== 'Homesite'" >
                <template v-slot:top="{ pagination, options, updateOptions }">
                    <v-data-footer prev-icon="<" :show-current-page="true"
                    next-icon=">" :pagination="pagination"
                        :options="options" @update:options="updateOptions"
                        items-per-page-text="$vuetify.dataTable.itemsPerPageText" />
                </template>
            </v-data-table>
            <v-dialog v-model="dialog" width="auto" fullscreen :scrim="false"
            transition="dialog-bottom-transition">
                <v-card>
                    <pdf-view v-bind:str-manifest-name="manifestName"
                    v-bind:str-company-name="strCompanyName"
                        @clicked="dialog = false"></pdf-view>
                </v-card>
            </v-dialog>
            <v-dialog v-model="noResults" max-width="500px">
              <v-card>
                <v-card-title>
                  Invalid search
                </v-card-title>
                <v-card-text>
                  <p v-if="currentSelection != 'Approved Date'">'{{ currentSelection }}' returned no results for '{{ inputValue }}'</p>
                  <p v-else>'{{ currentSelection }}' returned no results for '{{ date }} to {{ endDate }}'</p>
                  <p>Please validate your criteria and try again.</p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="noResults = false">Close</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
        </template>
    </view-card-template>
        <view-footer></view-footer>
</v-container>
</template>

<script>
import axios from 'axios';
import { Auth } from 'aws-amplify';
import { mapState, mapGetters } from 'vuex';
import ViewCardTemplate from '../components/templates/ViewCardTemplate.vue';
import ViewAppBar from '../components/templates/ViewAppBar.vue';
import PdfView from '../components/templates/PdfView.vue';
import ViewFooter from '../components/templates/ViewFooter.vue';

export default {
  name: 'table-view',
  components: {
    ViewCardTemplate,
    ViewAppBar,
    PdfView,
    ViewFooter
  },
  data: () => ({
    headers: [
      {
        text: 'Recipient Name',
        align: 'start',
        sortable: true,
        value: 'recipientName',
      },
      { text: 'Policy Number', value: 'accountNumber' },
      { text: 'Address', value: 'address' },
      { text: 'Manifest Name', value: 'manifest' },
      { text: 'Original Filename', value: 'originalFilename' },
      { text: 'Job Status', value: 'jobStatus' },
      { text: 'Approved Date', value: 'uploadDate' },
      { text: 'PDF', value: 'controls', sortable: false },
    ],
    csgHeaders: [
      {
        text: 'Recipient Name',
        align: 'start',
        sortable: true,
        value: 'recipientName',
      },
      { text: 'Policy Number', value: 'accountNumber' },
      { text: 'Address', value: 'address' },
      { text: 'Manifest Name', value: 'manifest' },
      { text: 'GUID', value: 'originalFilename' },
      { text: 'Job Status', value: 'jobStatus' },
      { text: 'Cycle Date', value: 'cycleDate' },
      { text: 'PDF', value: 'controls', sortable: false },
    ],
    headersInitial: [
      {
        text: 'Job ID',
        align: 'start',
        sortable: true,
        value: 'jobId',
      },
      { text: 'File Name', value: 'fileName' },
      { text: 'Job Status', value: 'jobStatus' },
      { text: 'Approved Date', value: 'uploadDate' },
    ],
    csgHeadersInitial: [
      {
        text: 'Job ID',
        align: 'start',
        sortable: true,
        value: 'jobId',
      },
      { text: 'File Name', value: 'fileName' },
      { text: 'Job Status', value: 'jobStatus' },
      { text: 'Upload Date', value: 'uploadDate' },
    ],
    inputValue: null,
    item: 'test',
    tableData: [],
    initialData: [],
    dropDown: ['Policy Number', 'Approved Date', 'Recipient Name', 'Manifest Name', 'Original Filename', 'Print Filename'],
    csgDropDown: ['Policy Number', 'Cycle Date', 'Recipient Name', 'Manifest Name', 'GUID'],
    currentSelection: 'Policy Number',
    initialLoad: '',
    date: new Date().toISOString().substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    menu3: false,
    isDate: false,
    search: '',
    dialog: false,
    manifestName: '',
    strCompanyName: '',
    noResults: false,
    errorString: ''
  }),
  computed: {
    ...mapState(['user']),
    ...mapGetters(['getUser']),
    user() {
      return this.getUser;
    },
  },
  async mounted() {
     await this.getAttributes()
     this.getInitialData('In Progress')
  },
  methods: {
    async getData(searchType, searchValue) {
      this.initialData = [];
      this.tableData = [];
      const inputText = searchValue;
      let data;
      switch (searchType) {
        case 'Policy Number':
          data = JSON.stringify({ AccountNumber: inputText, companyName: this.strCompanyName });
          break;
        case 'Job Status':
          data = JSON.stringify({ jobStatus: inputText, companyName: this.strCompanyName });
          break;
        case 'Recipient Name':
          data = JSON.stringify({ recipientName: inputText, companyName: this.strCompanyName });
          break;
        case 'Print Filename':
          data = JSON.stringify({ recordsByFilename: inputText, companyName: this.strCompanyName });
          break;
        case 'Original Filename':
          data = JSON.stringify({ originalFilename: inputText, companyName: this.strCompanyName });
          break;
        case 'GUID':
          data = JSON.stringify({ originalFilename: inputText, companyName: this.strCompanyName });
          break;
        case 'Manifest Name':
          data = JSON.stringify({ manifest: inputText, companyName: this.strCompanyName });
          break;
        case 'Approved Date':
          data = JSON.stringify({
            startDate: this.date,
            endDate: this.endDate,
            companyName: this.strCompanyName,
          });
          break;
        case 'Cycle Date':
          data = JSON.stringify({
            startDate: this.date,
            endDate: this.endDate,
            companyName: this.strCompanyName,
          });
          break;
        default:
      }
      const config = {
        method: 'post',
        url: process.env.VUE_APP_API_URL_PROD,
        headers: {
          'x-api-key': process.env.VUE_APP_API_KEY,
          'Content-Type': 'application/json',
        },
        data,
      };
      try{
        const response = await axios(config);
        const arrObjects = response.data;
        if(arrObjects.length === 0) this.noResults = true 
        else {
        if (searchType === 'Job Status') this.initialData = arrObjects;
        else this.tableData = arrObjects;
        this.initialLoad = false;
      }
      } catch (e) {
        this.errorString = 'Error fetching Data.  Please validate your search.'
        this.noResults = true 
      }
      
    },
    async getInitialData(status) {
      let jobStatus = status;
      const company = this.strCompanyName;
      const data = JSON.stringify({ jobStatus, companyName: company });
      const config = {
        method: 'post',
        url: process.env.VUE_APP_API_URL_PROD,
        headers: {
          'x-api-key': process.env.VUE_APP_API_KEY,
          'Content-Type': 'application/json',
        },
        data,
      };
      const response = await axios(config);
      const arrObjects = response.data;
      this.initialData = arrObjects;
    },

    updateBoolean(event) {
      if (event === 'Approved Date' || event === 'Cycle Date') this.isDate = true;
      else this.isDate = false;
    },
    reset() {
      this.tableData = [];
      this.initialData = [];
      this.inputValue = '';
      this.search = '';
      this.getInitialData('In Progress');
      this.dialog = false;
      this.date = null;
      this.endDate = null;
    },
    onButtonClick(item) {
      const company = this.strCompanyName;
      if (company === 'Homesites') {
        let strFilename = item.manifest.split('.');
        strFilename = `${strFilename[0]}.${strFilename[1]}.${strFilename[2]}.${strFilename[3]}.${strFilename[4]}.${strFilename[5]}.${strFilename[6]}`;
        this.manifestName = strFilename;
      } else this.manifestName = item.manifest;
      this.companyName = company;
      this.dialog = true;
    },
    async getAttributes() {
      let user = await Auth.currentAuthenticatedUser();
      this.strCompanyName = user.attributes['custom:companyName'];
    },
  },
  created() {
    //const groups = this.user.signInUserSession.accessToken.payload['cognito:groups'] || [];
    // eslint-disable-next-line
    // this.getAttributes()
    // this.strCompanyName = groups[0];
    // this.getInitialData('In Progress');
  },
};
</script>

<style lang="scss" scoped>
.image-fit {
    height: 100%;
    width: 100%;
    object-fit: cover;
}

.primaryLogo {
    font-style: italic;
    color: black;
    font-weight: 800;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 24pt;
}

.secondaryLogo {
    font-style: italic;
    color: blue;
    font-weight: 1000;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 24pt;
}

.login-container {
   background-image: url("~@/assets/background.png"); /* Replace with the path to your PNG image */
   background-size: cover;
   background-position: center;
   min-height: 100vh;
 }
 .my-pagination {
    .v-data-footer .v-icon {
        & .v-pagination__navigation {
            background: blue !important;
        }

        /*For page buttons except the active one*/
        & .v-pagination__item:not(.v-pagination__item--active) {
            background: yellow !important;
        }
    }
}
.v-slider__thumb{
  cursor:pointer;
}
.borderBottomThinSolidGray {
  border-top: thin solid rgba(0, 0, 0, 0.12);
}

.theme--light.v-data-table .v-data-footer {
  border-top: none !important;
}

.v-application .elevation-1 {
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0) !important;
}

.marginNone {
  margin: 0%;
}
</style>
